import { FormRuleCondition } from './form-rule-condition';
import { FormRuleOutcome } from './form-rule-outcome';

export type FormRule = {
  form_rule_id: string;
  form_element_id: string;
  order: number;
  type: string;
  created_at: Date;
  updated_at: Date;

  conditions: FormRuleCondition[];
  outcomes: FormRuleOutcome[];
};

export const enum FormRuleType {
  If = 'if',
  Always = 'always',
  SkipIf = 'skip-if',
}

export const FormRuleTypes = [
  { label: 'If', value: FormRuleType.If },
  { label: 'Always', value: FormRuleType.Always },
  { label: 'Skip if', value: FormRuleType.SkipIf },
];
